import { useDialog } from '@if/mui'
import { Metro2Reporting } from '@src/types/loan/loan-calendar'
import { History } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import Metro2ReportingHistoryTable from './Metro2ReportingHistoryTable'

export interface Metro2ReportingHistoryDialogProps {
  reportings: Metro2Reporting[]
}

/** Read-only: everything the loan has reported, stacked over the reporting dialog. */
export const useMetro2ReportingHistoryDialog = () => {
  const { t } = useTranslation()

  return useDialog<Metro2ReportingHistoryDialogProps>({
    icon: History,
    title: t('loan.payment.creditReportDialog.history'),
    cancelLabel: t('common.close'),
    maxWidth: 'lg',
    fullWidth: true,
    edgeToEdge: true,
    hideConfirm: true,
    content: (ctx) => <Metro2ReportingHistoryTable reportings={ctx.props.reportings} />,
  })
}
